import React, { lazy, Suspense } from 'react'
import { Route, Routes, Outlet, useLocation, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { LoadIndicator } from 'devextreme-react'
import ManualUploads from '../pages/ManualUploads/ManualUploads'

// Lazy load components
import HowItWorks from '../pages/HowItWorks/HowItWorks'
import Scripts from '../pages/Scripts/Scripts'
import Configs from '../pages/Configs/Configs'
// import Results from '../pages/Results/Results'
import ResultsPage from '../pages/Results/ResultsPage'
import Analyzers from '../pages/Analyzers/Analyzers'
import DataSetList from '../pages/Datasets/DataSetList'
import DataSetGenerator from '../pages/Datasets/DataSetGenerator/DataSetGenerator'
import DynamicDatasetsPage from '../pages/Datasets/DynamicDatasets/DynamicDatasetsPage'
import SystemHealth from '../pages/SystemHealth/SystemHealth'
import LoginPage from '../pages/Login/Login'
import Layout from './Layout'
import DataGroupsPage from '../pages/Data/DataGroupsPage'
import LostPassword from '../pages/LostPassword/LostPassword'
import SSO from '../pages/SSO/SSO'
import { useAppSelector } from '../hooks/useAppSelector'
import { LogoutPage } from '../pages/Logout/Logout'
import Service29 from '../pages/Service29/Service29'
import DeviceUpdatesPage from '../pages/DeviceUpdates/DeviceUpdates'

export const AppRoutes = () => {
  const accessToken = useAppSelector((state) => state.session.data.accessToken)
  const isAuthenticated = accessToken ? true : false
  const location = useLocation()
  return (
    <Routes>
      <Route path="/ui2/systemHealth" element={<SystemHealth />} />
      <Route path="/ui2/login" element={<LoginPage />} />
      <Route path="/ui2/sso" element={<SSO />} />
      <Route
        path="/ui2/lostpassword"
        element={
          <LostPassword
            visible={true}
            onHiding={() => {
              return
            }}
          />
        }
      />
      <Route
        path="/ui2"
        element={
          !isAuthenticated ? (
            <Navigate to="/ui2/login" state={{ from: location }} replace />
          ) : (
            <Layout />
          )
        }
      >
        <Route path="/ui2/data/groups" element={<DataGroupsPage />} />
        <Route path="/ui2/service29" element={<Service29 />} />
        <Route element={<RequireIPA />}>
          <Route path="/ui2/datasetlist" element={<DataSetList />} />
          <Route path="/ui2/analyzers" element={<Analyzers />} />
          <Route
            path="/ui2/scripts/:scriptId/configurations"
            element={<Configs />}
          />
          <Route path="/ui2/scripts" element={<Scripts />} />
          <Route path="/ui2/howitworks" element={<HowItWorks />} />
          <Route path="/ui2/results" element={<ResultsPage />} />
          <Route path="/ui2/devices/fleetManager" element={<DeviceUpdatesPage />} />
          <Route path="/ui2/datasets/generate" element={<DataSetGenerator />} />
          <Route
            path="/ui2/datasets/dynamic"
            element={<DynamicDatasetsPage />}
          />
          <Route path="/ui2/datasets" element={<DataSetList />} />
          {/* <Route path="/ui2/server/jobQueue" element={<JobQueue />} /> */}
        </Route>
        <Route path="/ui2/logout" element={<LogoutPage />} />
      </Route>
      <Route path="/ui2/manualUploads/:deviceId" element={<ManualUploads />} />
    </Routes>
  )
}

const SecureRoute = (props: { path; element }) => {
  //todo make this work
  const user = useAppSelector((state: any) => state.session.data.user)
  const accessToken = useAppSelector((state) => state.session.data.accessToken)
  const location = useLocation()
  const isAuthenticated = accessToken != null ? true : false

  if (!isAuthenticated) {
    //TODO: change back to /ui2/login when new lform is implemented
    <Navigate to="/ui2/login" state={{ from: location }} replace />
    return null
  }

  return isAuthenticated ? (
    <Route {...props} />
  ) : (
    <Navigate to="/ui2/login" state={{ from: location }} replace />
  )
}

const RequireIPA = () => {
  const user = useAppSelector((state: any) => state.session.data.user)
  //should be removed after syncing user
  const ipaAccess = user?.roles?.includes('ipa') || user?.ipa == true

  if (!ipaAccess) {
    //todo Display feature not available
    window.location.replace('/ui/#!/')
  }

  return <Outlet />
}
